var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-collection-card my-2 py-2 px-4 d-flex align-items-center",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{staticClass:"collapse-parameter-icon mr-1",style:(_vm.iconStyle),attrs:{"icon":['fad', _vm.iconValue]}}),_vm._v(" "+_vm._s(_vm.collection.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }